import { Field } from './Field';
import { IMultiField } from './IMultiField';
import { ComparisonType } from './ComparisonType';
import { Tag } from '../../tagging/Tag';
import { ListItem } from '../../controls/ListItem';

export class MultiSearchTermField extends Field implements IMultiField<Tag> {
  public values: Tag[];
  public searchTermList: ListItem[];

  constructor(name: string, description: string, values: Tag[] = null, comparisonType: ComparisonType = null, searchTermList: ListItem[] = null) {
    super(name, description, MultiSearchTermField.typeName(), comparisonType);
    this.values = values;
    this.searchTermList = searchTermList;
  }

  public static typeName(): string {
    return "io.indexed.domainmodel.search.advanced.MultiSearchTermField";
  }
}
